import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "src/store/hooks"
import { fetchIndustries } from "src/store/slices/industrySlice";

const useIndustries = () => {
  const dispatch = useAppDispatch();

  const { items, loading, loaded, error} = useAppSelector((state) => state.industries)

  useEffect(() => {
    if (!loaded && !loading && !error) {
      dispatch(fetchIndustries());
    }
  }, [dispatch, loaded, loading, error])

  return {industries: items, error, loading, loaded};
} 

export default useIndustries;